/**
 * Configuration composable
 * Provides easy access to runtime configuration values
 */
export const useConfig = () => {
  const { app } = useWhitelabel()

  return {
    // API configuration - always use /api for proxy routing
    apiBaseUrl: '/api',
    // Whitelabel configuration
    app
  }
}
